import React from 'react';
import { MeterChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildChartTitle, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToGroupValue(panelData, chart);
                const total = data.reduce((sum, e) => sum + e.value, 0);
                const colorScale = buildColorScale(data);
                const options = {
                    title: buildChartTitle(chart),
                    height: "400px",
                    meter: { proportional: { total } },
                    color: { scale: colorScale }
                };
                return <MeterChart options={options} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
